/**
 * Constants definition.
 *
 * @type {{DEFAULT: string, ON_DISSOLVE_PROCESS: string, DISSOLVED: string}}
 */
const COMPANY_STATUS = {
  DEFAULT: 'DEFAULT',
  ON_DISSOLVE_PROCESS: 'ON_DISSOLVE_PROCESS',
  DISSOLVED: 'DISSOLVED',
  CANCELED: 'CANCELED',
  ARCHIVED: 'ARCHIVED',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const COMPANY_STATUS_ENUM = Object.keys(COMPANY_STATUS);

export {
  COMPANY_STATUS,
  COMPANY_STATUS_ENUM,
};
